import ApiErrorFactory from '../utils/errors'
import AccountStore from './Account'
import { ResponseError as ResErr, Response } from 'superagent'
import agent, { SuperAgentRequest } from 'superagent'

export interface ResponseError extends ResErr {
  response: Response
}

enum HTTPMethod {
  get = 'get',
  post = 'post',
  put = 'put',
  patch = 'patch',
  del = 'del'
}

const ongoingRequests: { [url: string]: SuperAgentRequest } = {}

function _request(
  method: HTTPMethod,
  url: string,
  data: any = null,
  cb = (_?: Error) => {},
  headers?: any
): Promise<any> {
  const fullUrl = `${import.meta.env.REACT_APP_API_URL}${url}`

  if (ongoingRequests[fullUrl] !== undefined) {
    ongoingRequests[fullUrl].abort()
    delete ongoingRequests[fullUrl]
  }

  const req = agent[method](fullUrl).timeout(45_000)

  ongoingRequests[fullUrl] = req

  if (headers) {
    req.set(headers)
  }

  if (method === HTTPMethod.get) {
    req.query(data)
  } else {
    req.send(data)
  }

  return req
    .withCredentials()
    .then((res: Response) => {
      cb(undefined)
      AccountStore.setLastRequestTimestamp()
      delete ongoingRequests[fullUrl] // Clear after success
      return res.body
    })
    .catch((error: ResponseError) => {
      let apiError

      if (!error.status) {
        cb()
        delete ongoingRequests[fullUrl] // Clear after failure
        throw 'timeout'
      }

      const reason = error.response.body ? error.response.body.error : ''
      apiError = ApiErrorFactory(error.response.status, reason)
      cb(apiError)
      delete ongoingRequests[fullUrl] // Clear after failure
      throw apiError
    })
}

export function get(url: string, query: any = null, cb = (_?: Error) => {}, headers: any = null) {
  return _request(HTTPMethod.get, url, query, cb, headers)
}

export function post(url: string, data: any = null, cb = (_?: Error) => {}, headers: any = null) {
  return _request(HTTPMethod.post, url, data, cb, headers)
}

export function put(url: string, data: any = null, cb = (_?: Error) => {}, headers: any = null) {
  return _request(HTTPMethod.put, url, data, cb, headers)
}

export function del(url: string, data: any = null, cb = (_?: Error) => {}, headers: any = null) {
  return _request(HTTPMethod.del, url, data, cb, headers)
}
